import React from 'react'
import { Route as ReactRouterRoute } from 'react-router-dom'

export const Route = ({ ...props }) => <ReactRouterRoute {...props} />

export const DevRoute = ({ ...props }) => <ReactRouterRoute {...props} />

export const AdminRoute = ({ ...props }) => <ReactRouterRoute {...props} />
